/* global dataLayer */
import { activityLoggerService } from './ActivityLoggerService';
import $ from 'jquery';

export default {
    init() {
        const lsName = 'takeover-keukendetail';
        var objTakeOver = { closed: false };

        if (window.sessionStorage && window.sessionStorage.getItem(lsName)) {
            objTakeOver = JSON.parse(window.sessionStorage.getItem(lsName));
        };

        if (!objTakeOver.closed) {
            var elKeukenDetail = $('.keukendetail');
            if (elKeukenDetail.length) {
                elKeukenDetail.addClass('show fade');
            }
        }

        // Bind lifestyle buttons
        $('.lifestyle-group .lifestyle').on('click', function () {
            let style = $(this).val();
            activityLoggerService.logConfiguratorActivity({ 'ActivityCodeName': 'Takeover.Style', 'ActivityTitle': `Style '${style}' chosen`, 'ActivityValue': style });

            // Log Google Analytics
            dataLayer.push({
                'event': 'TakeoverClick',
                'detail': {
                    'ActivityCodeName': 'Takeover.Style',
                    'ActivityTitle': `Style '${style}' chosen`,
                    'ActivityValue': style
                }
            });
        });

        // Bind situation buttons
        $('.situation-group .situation').on('click', function () {
            let situation = $(this).val();
            activityLoggerService.logConfiguratorActivity({ 'ActivityCodeName': 'Takeover.Situation', 'ActivityTitle': `Situation '${situation}' chosen`, 'ActivityValue': situation });

            // Log Google Analytics
            dataLayer.push({
                'event': 'TakeoverClick',
                'detail': {
                    'ActivityCodeName': 'Takeover.Situation',
                    'ActivityTitle': `Situation '${situation}' chosen`,
                    'ActivityValue': situation
                }
            });
        });

        // Bind close/cancel buttons
        $('#takeOverlay .close-keukendetail-takeover').on('click', function () {
            objTakeOver.closed = true;
            window.sessionStorage.setItem(lsName, JSON.stringify(objTakeOver));
            activityLoggerService.logConfiguratorActivity({ 'ActivityCodeName': 'Takeover.Closed', 'ActivityTitle': `Takeover 'Keukendetail' closed`, 'ActivityValue': 'Keukendetail' });
        });
    }
};



// WEBPACK FOOTER //
// ./CMS/scripts/modules/TakeOverActivityLogger.js